
import { getUrlParams, parseJson, commonParseQuery } from './common-utils';

export const parseReviewPageUrlToConfig = (url) => {
  const searchParams = getUrlParams(url);
  const { qryParams = '{}' } = searchParams;
  const parsedJson = parseJson(qryParams); 
  const { v_d = "", s_d = "", s_i = "", s_n = "", d_i = "", d_n = "", s_t = "", e_t = "", t_t = "", rf = "", v_t = "", off = 0, r_off = 0, pc = "", flow = "", isSeo = false,is_ryde, package_id = '', packageTime = '' } = parsedJson;
  const { newSDate, newSTime, newEDate, newETime } = commonParseQuery({ s_t, e_t, off, r_off });
  const parseData = {
    key: v_d,
    dispatchSearchId: s_d,
    vehicle_type: v_t,
    source: {
      place_id: s_i,
      name: s_n,
    },
    destination: {
      place_id: d_i,
      name: d_n
    },
    startDate: {
      date: newSDate,
      time: newSTime[0]
    },
    endDate: {
      date: newEDate,
      time: newETime[1]
    },
    tripType: {
      name: e_t || r_off ? 'ROUND_TRIP' : t_t,
      rf: e_t || r_off ? 'rt' : rf
    },
    package_id,
    packageTime,
    isSeo: !!(s_n && s_i && d_i && d_n && t_t) || !!isSeo,
    pc,
    flow,
    is_ryde
  };
  return parseData;
}

export default parseReviewPageUrlToConfig;